import { render, staticRenderFns } from "./AutoStorichePage.vue?vue&type=template&id=cf9b1f22"
import script from "./AutoStorichePage.vue?vue&type=script&lang=js"
export * from "./AutoStorichePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports